<template>
  <main class="group-au-page">
    <div class="page-content-wrapper">
      <div v-if="loading" class="page-loading-overlay">
        <default-loading></default-loading>
      </div>
      <CompanyBreadcrumb :aria-label="isEditMode ? $t('user_group.edit') : $t('user_group.create')"
                         :home-aria-label="$t('general.home')"
                         :items="breadcrumbItems"
      />

      <div v-if="(formErrors && formErrors.length) || successMessage" class="card group-au-alert-card">
        <div v-for="(error, index) in formErrors" :key="'err-' + index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
        <div v-if="successMessage" class="uk-alert-success" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: green">
            <i class="uil-check"></i>
            {{ $t("general.update_success") }}
          </p>
        </div>
      </div>

      <div class="card group-au-card">
        <CompanyTabs :tabs="groupTabs"
                     animation="uk-animation-fade"
                     class="group-au-tabs-shell"
                     content-id="group-au-switcher"
                     nav-id="group-au-tabs"
        >
          <!-- Tab 1: Group info -->
          <li>
            <div v-if="isEditMode && loading" class="course-card-body group-au-card-body">
              <default-loading></default-loading>
            </div>
            <div v-else class="course-card-body group-au-card-body">
              <form action="" class="regular-form group-au-form">
                <div class="uk-grid-collapse uk-child-width-1-1" uk-grid>
                  <div class="position-relative">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label class="col-form-label" for="name">{{
                            $t("user_group.list.name")
                          }}<span class="required">*</span></label>
                        <input id="name" v-model="form.name" class="form-control" name="name" placeholder=""
                               required="" type="text"/>
                      </div>
                    </div>
                    <div class="form-group row mt-3 input-checkbox">
                      <div class="col-md-12">
                        <div class="group-au-checkbox">
                          <input id="status" v-model="form.status" type="checkbox"/>
                          <label for="status">{{
                              $t("user_group.list.active")
                            }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </li>
          <!-- Tab 2: Users -->
          <li>
            <div class="card-header actions-toolbar border-0 group-au-toolbar">
              <div class="d-flex justify-content-between align-items-center group-au-toolbar-inner">
                <div v-if="isEditMode" class="group-au-search">
                  <form class="uk-search uk-search-navbar group-au-search-field" @submit.prevent>
                    <span aria-hidden="true" class="uk-search-icon group-au-search-icon">
                      <i class="uil-search"></i>
                    </span>
                    <input v-model="filter.search"
                           :aria-label="$t('general.search')"
                           :placeholder="$t('general.search')"
                           class="uk-search-input"
                           type="search"
                    />
                  </form>
                </div>
                <div class="d-flex group-au-toolbar-actions">
                  <a class="uk-button uk-button-primary small group-au-user-btn" href="javascript:void(0)"
                     type="button"
                     @click.prevent="addUsersModalOpen = true">
                    <i class="uil-user-plus"></i>
                    {{ $t("user_group.add_user_group") }}
                  </a>
                  <template v-if="isEditMode">
                    <sort-dropdown :sort-options="sortOptions" @sort-selected="sortOrder"/>
                    <a :uk-tooltip="$t('general.filter_list')" class="btn btn-icon btn-hover btn-circle"
                       href="javascript:void(0)">
                      <i class="uil-filter"></i>
                    </a>
                    <UserFilter id="userFilterGroup" @getFilter="getFilter($event)"></UserFilter>
                  </template>
                </div>
              </div>
            </div>
            <div v-if="isEditMode && loading">
              <default-loading></default-loading>
            </div>
            <div v-else class="sf-table group-au-table-wrap">
              <table>
                <thead>
                <tr>
                  <th scope="col">
                    {{ $t("user_group.list.first_lastname") }}
                  </th>
                  <th scope="col">
                    {{ $t("user_group.list.user_title") }}
                  </th>
                  <th scope="col">
                    {{ $t("user_group.list.added_date") }}
                  </th>
                  <th class="sf-table__col-actions" scope="col"></th>
                </tr>
                </thead>
                <tbody class="list">
                <template v-for="(item, index) in displayUsers">
                  <tr :key="'user-' + item.id">
                    <th scope="row">
                      <div class="sf-table__media">
                        <div class="avatar-parent-child" style="width: max-content">
                          <img :alt="item.fullname || ''" :src="item.photo_link" class="avatar rounded-circle"/>
                          <span :class="item.is_online ? 'bg-success' : 'bg-offline'"
                                class="avatar-child avatar-badge"></span>
                        </div>
                        <div class="sf-table__media-body">
                          <!-- href="#" YOK: router hash modunda (router.js:11
                               history kapali), `#` hash'i silip kok route'a
                               atiyordu. Isim de satirdaki profil ikonuyla ayni
                               isi yapar: profil modalini acar. -->
                          <a class="sf-table__name"
                             @click="isEditMode && (activeItem = item)">{{
                              item.fullname
                            }}</a>
                          <small class="sf-table__meta">#{{ item.id }}</small>
                        </div>
                      </div>
                    </th>
                    <td>{{ item.title }}</td>
                    <td>{{ item.created_at }}</td>
                    <td class="sf-table__col-actions">
                      <div class="sf-table__actions group-au-row-actions">
                        <!-- uk-toggle yok: hedef henuz DOM'da olmadigi icin
                             UIkit bu <a>'yi gizliyordu. Modal kendini aciyor. -->
                        <a :uk-tooltip="$t('general.user_profil')"
                           class="btn btn-icon btn-hover btn-sm btn-circle"
                           @click="isEditMode && (activeItem = item)">
                          <i class="uil-user"></i>
                        </a>
                        <a :uk-tooltip="$t('general.remove_user_from_group')"
                           class="btn btn-icon btn-hover btn-sm btn-circle"
                           @click="removeUserGroup(item.id)">
                          <i class="uil-minus-circle text-danger"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </li>
        </CompanyTabs>
      </div>
      <div class="uk-modal-footer uk-text-right bggray group-au-footer">
        <button class="uk-button uk-button-default bg-white small mr-3 group-au-back-btn"
                @click="$router.push({ name: 'company.user.group' })">
          {{ $t("general.back") }}
        </button>
        <button class="uk-button uk-button-primary small group-au-save-btn" type="button" @click="saveForm()">
          {{ $t("general.save") }}
        </button>
      </div>
    </div>

    <!-- edit: zaten grupta olanlar dışlanır (id dizisi)
         ekle: seçili olanlar ön seçili gelir (nesne dizisi) -->
    <AddToGroupModal :existing_users="isEditMode ? existingUsers : []"
                     :has_user_status="isEditMode"
                     :selected_users="isEditMode ? [] : form.userGroup"
                     :visible.sync="addUsersModalOpen"
                     @getList="getList($event)"
    />
    <!-- modalClosed şart: activeItem sıfırlanmazsa modal bir daha açılmaz -->
    <UserProfile v-if="isEditMode && formattedUserDetail && activeItem"
                 :item="activeItem"
                 :user_detail="formattedUserDetail"
                 @modalClosed="activeItem = null"/>
  </main>
</template>

<script>
import store from "@/core/services";
import moment from "moment";
import Pagination from "@/assets/components/Pagination";
import AddToGroupModal from "@/view/company/User/Group/AddToGroupModal";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import CompanyBreadcrumb from "@/view/company/components/breadcrumb/CompanyBreadcrumb.vue";
import SortDropdown from "@/view/components/dropdown/SortDropdown.vue";
import CompanyTabs from "@/view/company/components/tabs/CompanyTabs.vue";
import UserFilter from "@/view/company/User/Filter";
import UserProfile from "@/view/company/User/UserProfile/index.vue";
import module, {
  BASE_URL,
  CREATE_ITEM,
  GET_ITEM,
  ITEM,
  MODULE_NAME,
  ERROR,
  UPDATE_ITEM,
  LOADING,
} from "@/core/services/store/user_group.module";
import $ from "jquery";
import company_module, {
  ONLINE_USERS,
  MODULE_NAME as COMPANY_MODULE,
} from "@/core/services/store/company.module";
import user_detail_module, {
  GET_ITEM as GET_USER_DETAIL,
  ITEM as USER_DETAIL,
  MODULE_NAME as USER_DETAIL_MODULE,
} from "@/core/services/store/user_detail.module";

const _COMPANY_MODULE = COMPANY_MODULE;
const _USER_DETAIL_MODULE = USER_DETAIL_MODULE;

export default {
  name: "UserGroupAddUpdate",
  components: {
    Pagination,
    AddToGroupModal,
    DefaultLoading,
    CompanyBreadcrumb,
    SortDropdown,
    UserFilter,
    UserProfile,
    CompanyTabs,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(MODULE_NAME, module);
    registerStoreModule(_COMPANY_MODULE, company_module);
    registerStoreModule(_USER_DETAIL_MODULE, user_detail_module);
  },
  data() {
    return {
      addUsersModalOpen: false,
      activeItem: null,
      form: {
        name: "",
        status: true,
        userGroup: [],
      },
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      formErrors: [],
      successMessage: false,
    };
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    },
    groupTabs() {
      return [
        { key: "info", icon: "uil-info-circle", label: this.$t("user_group.information") },
        { key: "users", icon: "uil-users-alt", label: this.$t("user_group.group_user") },
      ];
    },
    breadcrumbItems() {
      return [
        { name: this.$t("user_group.users") },
        { name: this.$t("user_group.title") },
        { name: this.isEditMode ? this.$t("user_group.edit") : this.$t("user_group.create") },
      ];
    },
    sortOptions() {
      return [
        {
          key: "name-asc",
          sort: "name",
          order: "asc",
          label: this.$t("sorting.a_z"),
        },
        {
          key: "name-desc",
          sort: "name",
          order: "desc",
          label: this.$t("sorting.z_a"),
        },
        {
          key: "created_at-asc",
          sort: "created_at",
          order: "asc",
          label: this.$t("sorting.created_at_old"),
        },
        {
          key: "created_at-desc",
          sort: "created_at",
          order: "desc",
          label: this.$t("sorting.created_at_new"),
        },
      ];
    },
    displayUsers() {
      if (this.isEditMode) {
        return this.formattedItem;
      }
      return this.form.userGroup;
    },
    formattedItem() {
      if (this.item === null || !("users" in this.item)) {
        return null;
      }
      let results = this.fixUserGroup();
      this.form = this.item;
      this.form.userGroup = results;
      return results;
    },
    user_detail: {
      get() {
        return store.getters[USER_DETAIL_MODULE + "/" + USER_DETAIL];
      },
      set(value) {
      },
    },
    formattedUserDetail() {
      if (this.user_detail === null) return null;
      return this.user_detail;
    },
    existingUsers() {
      if (this.form && this.form.userGroup) {
        return _.map(this.form.userGroup, "id");
      }
      return [];
    },
    onlineUsers() {
      return store.getters[_COMPANY_MODULE + "/" + ONLINE_USERS];
    },
    item: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEM];
      },
      set(value) {
      },
    },
    errors: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    loading() {
      return store.getters[MODULE_NAME + "/" + LOADING];
    },
  },
  methods: {
    getUserDetail(id) {
      store.dispatch(USER_DETAIL_MODULE + "/" + GET_USER_DETAIL, {
        url: "api/user/detail-admin" + "/" + id,
      });
    },
    getFilter(value) {
      this.filterResult(value);
    },
    fixUserGroup() {
      let results = [];
      this.item.users.forEach((item) => {
        results.push({
          id: item.id,
          name: item.name,
          surname: item.surname,
          dob: item.dob ? item.dob : "-",
          email: item.email,
          phone: item.phone,
          status_id: item.status_id,
          is_online: this.onlineUsers.find(
              (onlineUser) => onlineUser.user == item.id && onlineUser.status
          )
              ? true
              : false,
          photo_link: item.photo_link,
          fullname: [item.name, item.surname].join(" "),
          title: item.title ? item.title.name : "-",
          created_at: item?.pivot?.created_at
              ? moment(item?.pivot?.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          last_login_at: item.last_login_at
              ? moment(item.last_login_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
        });
      });
      return results;
    },
    saveForm() {
      this.addUsersModalOpen = false;
      let self = this;
      let form = self.form;

      self.formErrors = [];
      if (form.name.length == 0) {
        self.formErrors.push(self.$t("user_group.required.name"));
        self.scrollToTop();
        return false;
      }

      let ids = [];
      form.userGroup.forEach((item) => {
        ids.push(item.id);
      });

      if (this.isEditMode) {
        form.user_ids = ids;
        store
            .dispatch(MODULE_NAME + "/" + UPDATE_ITEM, {
              url: BASE_URL + "/" + this.$route.params.id,
              contents: form,
              returnType: "stateless",
              acceptPromise: true,
            })
            .then((response) => {
              if (response) {
                this.setDefaultData();
              }
            });
      } else {
        store
            .dispatch(MODULE_NAME + "/" + CREATE_ITEM, {
              url: BASE_URL,
              contents: {
                name: form.name,
                status: form.status,
                user_ids: ids,
              },
            })
            .then(() => {
              if (!this.errors) self.$router.push({ name: "company.user.group" });
            });
      }
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    getList(value) {
      if (this.isEditMode) {
        value.forEach((item) => {
          this.item.users.push(item);
          this.form.userGroup.push(item);
        });
        this.saveForm();
      } else {
        this.form.userGroup = Array.isArray(value) ? value.map((item) => ({ ...item })) : [];
      }
    },
    removeUserGroup(index) {
      const deletedUserIndex = this.form.userGroup.findIndex(item => item.id === index);
      this.form.userGroup.splice(deletedUserIndex, 1);

      if (this.isEditMode) {
        const deletedUserGroupIndex = this.item.users.findIndex(item => item.id === index);
        this.item.users.splice(deletedUserGroupIndex, 1);
      }
    },
    sortOrder({ sort, order }) {
      this.page = 1;
      this.filter.order = order;
      this.filter.sort = sort;
      this.filterResult();
    },
    filterResult(filter = null) {
      let self = this;
      UIkit.dropdown("#userFilterGroup").hide();
      let filters = {
        like: self.filter.search,
        page: self.page,
        per_page: self.per_page,
        sort: self.filter.sort,
        order: self.filter.order,
      };
      if (filter) {
        filter.company_id ? (filters["company_id"] = filter.company_id) : null;
        filter.company_id = null;
        $.each(filter, function (key, value) {
          if (value && Array.isArray(filter[key])) {
            let ids = [];
            filter[key]?.forEach((items) => {
              ids.push(items.id);
            });
            filters[key] = JSON.stringify(ids);
          }
        });
      }
      store.dispatch(MODULE_NAME + "/" + GET_ITEM, {
        url: BASE_URL + "/" + this.$route.params.id,
        filters: filters,
      });
    },
    setDefaultData() {
      let filters = {
        like: this.filter.search,
        page: this.page,
        per_page: this.per_page,
        sort: this.filter.sort,
        order: this.filter.order,
      };
      store
          .dispatch(MODULE_NAME + "/" + GET_ITEM, {
            url: BASE_URL + "/" + this.$route.params.id,
            filters: filters,
          })
          .then((data) => {
            this.form = data;
            this.fixUserGroup();
          });
    },
  },
  mounted() {
    if (this.isEditMode) {
      this.setDefaultData();
    }
  },
  watch: {
    "filter.search": function (val) {
      if (this.isEditMode) {
        this.filterResult();
        this.debouncedFilterSearch = _.debounce(this.filterResult, 500);
      }
    },
    activeItem(value) {
      if (value && this.isEditMode) {
        this.getUserDetail(value.id);
      }
    },
  },
  beforeDestroy() {
    const modal = UIkit.modal("#modal-profile");
    if (modal) modal.$destroy(true);
  },
};
</script>
<style scoped>
.group-au-page {
  --group-au-primary: var(--primaryColor, #3e416d);
  --group-au-text: #1e293b;
  --group-au-muted: #64748b;
  --group-au-border: #e2e8f0;
  min-width: 0;
}

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}

.group-au-alert-card {
  margin-bottom: 16px;
  overflow: hidden;
  border: 1px solid var(--group-au-border);
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.page-content-wrapper {
  position: relative;
  min-width: 0;
}

.page-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 80px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(1px);
}

/* CompanyTabs kendi kart cercevesini cizmiyor; nav kart ici kenarlardan
   nefes alsin diye yatay bosluk burada veriliyor. */
.group-au-tabs-shell ::v-deep .company-tabs__nav {
  padding: 0 16px;
}

.group-au-card {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  margin-top: 0;
  background: #fff;
  border: 1px solid var(--group-au-border);
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.group-au-toolbar {
  padding: 16px;
}

.group-au-toolbar-inner {
  gap: 16px;
}

.group-au-search {
  flex: 1 1 auto;
  min-width: 0;
}

.group-au-search-field,
.group-au-search-field.uk-search-navbar {
  display: block;
  position: relative;
  width: 100%;
  max-width: 100%;
}

.group-au-search-icon,
.group-au-page ::v-deep .group-au-search-icon.uk-search-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  margin: 0;
  pointer-events: none;
  color: #3f87f5;
  font-size: 20px;
  line-height: 1;
}

.group-au-search-icon i.uil-search {
  position: static;
  top: auto;
  left: auto;
  font-size: 20px;
  line-height: 1;
}

.group-au-search .uk-search-input {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 16px 10px 40px !important;
  border: 1px solid #cfd5df;
  border-radius: 10px;
  background: #fff;
  color: var(--group-au-text);
  font-size: 14px !important;
  line-height: 1.4;
}

.group-au-search .uk-search-input:focus-visible {
  outline: 3px solid rgba(62, 65, 109, 0.25);
  outline-offset: 2px;
}

.group-au-toolbar-actions {
  align-items: center;
  gap: 8px;
}

.group-au-toolbar-actions .btn-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.group-au-form .col-form-label {
  display: block;
  margin-bottom: 8px;
  padding: 0;
  color: var(--group-au-text);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

.group-au-form .form-control {
  box-sizing: border-box;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #cfd5df;
  border-radius: 10px;
  color: var(--group-au-text);
  font-size: 15px;
  line-height: 1.5;
}

.group-au-form .row {
  margin-right: 0;
  margin-left: 0;
}

.group-au-form .row > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.group-au-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
}

.group-au-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.group-au-checkbox label {
  margin: 0;
  color: var(--group-au-text);
  font-size: 14px;
  line-height: 1.4;
}

.group-au-user-btn {
  padding: 10px 17px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.group-au-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding: 16px 0 0;
}

.group-au-back-btn,
.group-au-save-btn {
  box-sizing: border-box;
  padding: 10px 17px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.group-au-back-btn:active,
.group-au-save-btn:active,
.group-au-user-btn:active,
.group-au-row-actions .btn-circle:active,
.group-au-toolbar-actions .btn-circle:active {
  transform: scale(0.98);
  opacity: 0.85;
}

.group-au-row-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.group-au-row-actions .btn-circle {
  width: 30px;
  height: 30px;
}

.group-au-card-body {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 16px 17px;
}

/* Tablo tasarimi .sf-table'dan gelir (assets/scss/_data-table.scss).
   Bu sayfada zebra YOK; sistemin varsayilani (satir alt cizgisi) ayni
   gorunumu veriyor, bu yuzden --zebra eklenmedi. */

@media (max-width: 959px) {
  .group-au-page {
    padding: 0 0 24px;
  }

  .group-au-form .form-control {
    min-height: 48px;
    height: 48px;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 1.4;
  }

  .group-au-checkbox {
    min-height: 48px;
  }

  .group-au-checkbox label {
    font-size: 16px;
  }

  .group-au-user-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 48px;
    padding: 12px 16px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
  }

  .group-au-toolbar-inner {
    flex-direction: column;
    align-items: stretch !important;
  }

  .group-au-search,
  .group-au-toolbar-actions {
    width: 100%;
  }

  .group-au-search-icon,
  .group-au-page ::v-deep .group-au-search-icon.uk-search-icon {
    width: 48px;
  }

  .group-au-search .uk-search-input {
    width: 100%;
    height: 48px;
    min-height: 48px;
    padding: 12px 16px 12px 48px !important;
    font-size: 16px !important;
    line-height: 1.4;
  }

  .group-au-toolbar-actions .btn-circle {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
  }

  .group-au-card-body {
    padding: 16px;
  }

  /* Tablo mobilde sikistirilmaz, yatay kaydirilir */
  .group-au-table-wrap {
    --sf-table-min-width: 640px;
  }

  .group-au-row-actions .btn-circle {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
  }

  .group-au-back-btn,
  .group-au-save-btn {
    min-height: 48px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
  }
}

@media (max-width: 767px) {
  .group-au-page {
    padding: 0 0 24px;
  }

  .group-au-footer {
    flex-direction: row;
    align-items: stretch;
    gap: 8px;
    padding: 16px 0 0;
  }

  .group-au-back-btn,
  .group-au-save-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 0;
    width: auto;
    height: 48px;
    min-height: 48px;
    margin: 0 !important;
  }
}

@media (hover: hover) and (pointer: fine) {
  .group-au-back-btn,
  .group-au-save-btn,
  .group-au-user-btn,
  .group-au-page ::v-deep .group-au-tabs li a {
    cursor: pointer;
  }
}

@media (hover: none) {
  .group-au-page ::v-deep .btn-hover:hover {
    background-color: transparent;
  }
}

@media (prefers-reduced-motion: reduce) {
  .group-au-back-btn:active,
  .group-au-save-btn:active,
  .group-au-user-btn:active,
  .group-au-row-actions .btn-circle:active,
  .group-au-toolbar-actions .btn-circle:active {
    transform: none;
  }
}
</style>
